module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading-container"
    }
  }, [_c('div', {
    staticClass: "loading",
    class: {
      'nodisplay': _vm.suggestState && _vm.downloadState
    }
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-5x"
  })]), _vm._v(" "), _c('pageHeader'), _vm._v(" "), _c('b-container', {
    staticClass: "bottom-margin",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-container', [_c('div', {
    staticClass: "body-width"
  }, [_c('b-row', [_c('b-col', [_c('h1', {
    staticClass: "predict-title"
  }, [_vm._v("予測シミュレーション")])]), _vm._v(" "), _c('b-col', {
    staticClass: "predict-download"
  }, [_c('button', {
    staticClass: "predict-download__download-button",
    class: _vm.listState ? 'predict-download__download-button--clicked' : '',
    on: {
      "click": _vm.onCsvSelect
    }
  }, [_vm._v("\n              CSV "), _c('i', {
    staticClass: "fas fa-download"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "predict-download__ul",
    class: _vm.listState ? 'predict-download__ul--display' : 'predict-download__ul--nodisplay'
  }, [_c('li', {
    staticClass: "predict-download__li"
  }, [_c('a', {
    staticClass: "predict-download__a-item",
    on: {
      "click": _vm.onCsvMarkdown
    }
  }, [_vm._v("マークダウン")])]), _vm._v(" "), _c('li', {
    staticClass: "predict-download__li"
  }, [_c('a', {
    staticClass: "predict-download__a-item",
    on: {
      "click": _vm.onCsvItemOrder
    }
  }, [_vm._v("追加発注(品番)")])]), _vm._v(" "), _c('li', {
    staticClass: "predict-download__li"
  }, [_c('a', {
    staticClass: "predict-download__a-item",
    on: {
      "click": _vm.onCsvSkuOrder
    }
  }, [_vm._v("追加発注(SKU)")])]), _vm._v(" "), _c('li', {
    staticClass: "predict-download__li"
  }, [_c('a', {
    staticClass: "predict-download__a-item",
    on: {
      "click": _vm.onPredictCsvItemMarkdown
    }
  }, [_vm._v("マークダウン(日別)")])]), _vm._v(" "), _c('li', {
    staticClass: "predict-download__li"
  }, [_c('a', {
    staticClass: "predict-download__a-item",
    on: {
      "click": _vm.onPredictCsvItemOrder
    }
  }, [_vm._v("追加発注(日別)")])])])])], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "cols": "2"
    }
  }, [_c('categorylist')], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "cols": "5"
    }
  }, [_c('itemlist', {
    ref: "itemlist"
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "cols": "5"
    }
  }, [_c('skulist')], 1)], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('detail')], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "margin-left": "-52px",
      "padding": "0px"
    },
    attrs: {
      "md": "8"
    }
  }, [_c('simulate')], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780a3c08","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/predict/predict.vue
// module id = 701
// module chunks = 0